import type { EntityPermissions } from "./entity-definition";
import type { PermissionConstantDTO } from "../roles-permissions/roles-permissions.schemas";

export type EntityIdentityCompatibility = {
	backendAliases?: readonly string[];
	relationAuditKey?: string;
};

export type RecordActionGrants = Partial<
	Record<"create" | "update" | "delete", PermissionConstantDTO>
>;

export type RecordActionPermissions = {
	createPermission?: string;
	updatePermission?: string;
	deletePermission?: string;
};

export type EntityIdentity = {
	definitionKey: string | null;
	pageKey: string | null;
	nameSingular: string;
	namePlural: string;
	relationKey: string | null;
	auditKey: string | null;
	storage: "durable" | "synthetic";
	grants?: EntityPermissions;
	actions?: RecordActionGrants;
	compatibility?: EntityIdentityCompatibility;
};

export type EntityIdentityIndexes = {
	byDefinitionKey: Readonly<Record<string, EntityIdentity>>;
	byPageKey: Readonly<Record<string, EntityIdentity>>;
	byNameSingular: Readonly<Record<string, EntityIdentity>>;
	byNamePlural: Readonly<Record<string, EntityIdentity>>;
	byRelationKey: Readonly<Record<string, EntityIdentity>>;
	byAuditKey: Readonly<Record<string, EntityIdentity>>;
	backendAliases: Readonly<Record<string, string>>;
};

export function defineEntityIdentity<const T extends EntityIdentity>(identity: T): Readonly<T> {
	return Object.freeze(identity);
}
